import { userPreferencesService } from '@/services/user-preferences.service';

const initialState = () => ({
  userPreferences: null,
  status: {
    error: null,
    pending: true,
    saving: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getUserPreferences({ commit }) {
    commit('GET_USER_PREFERENCES');
    return userPreferencesService.getUserPreferences().then((response) => commit('SUCCESS', response));
  },
  updateUserPreferences({ commit }, userPreferences) {
    commit('SAVE_USER_PREFERENCES');
    return userPreferencesService
      .updateUserPreferences(userPreferences)
      .then((response) => commit('SUCCESS', response));
  },
};

const mutations = {
  GET_USER_PREFERENCES(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.userPreferences = null;
  },
  SAVE_USER_PREFERENCES(state) {
    state.status = {
      error: null,
      pending: false,
      saving: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state, userPreferences) {
    state.status = {
      ...state.status,
      pending: false,
      saving: false,
      resolved: true,
    };
    state.userPreferences = userPreferences;
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      saving: false,
      rejected: true,
      error: error,
    };
  },
};
const getters = {
  userPreferences: (state) => state.userPreferences,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  saving: (state) => state.status.saving,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const userPreferences = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
